import { forwardRef } from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { ICON_SIZE } from '../../icons';
import './Checkbox.css';

// shadcn Radix Checkbox anatomy; Reedle semantic tokens own its appearance.
const Checkbox = forwardRef(({ className = '', ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    data-slot="checkbox"
    className={`rds-checkbox ${className}`.trim()}
    {...props}
  >
    <CheckboxPrimitive.Indicator data-slot="checkbox-indicator" className="rds-checkbox__indicator">
      <Check size={ICON_SIZE.xs} aria-hidden="true" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));

Checkbox.displayName = 'Checkbox';

export default Checkbox;
